var map = {
	"./RGB-logo-zeedhi-ED-powered.png": "7c6d",
	"./RGB-logo-zeedhi-ED-simples.png": "9cdc",
	"./eattake-horizontal-branca-png.png": "29dd",
	"./placeholder.png": "5b4d",
	"./preferences.png": "10bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";